import React, { Component } from 'react'
import PropTypes from 'prop-types'
import AdminTableComponent from 'routes/Admin/components/CommonComponents/AdminTableComponent'
import Tab from '@material-ui/core/Tab'
import Tabs from '@material-ui/core/Tabs'
import { withStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import {
  MODAL_ADMIN_EDIT_CUSTOMER,
  MODAL_ADMIN_CREATE_CUSTOMER
} from 'redux/modules/modals'
const columnDataAll = [
  {
    id: 'customers_last_name',
    numeric: false,
    disablePadding: true,
    label: 'Nom'
  },
  {
    id: 'customers_first_name',
    numeric: false,
    disablePadding: true,
    label: 'Prénom'
  },
  {
    id: 'customers_email',
    numeric: false,
    disablePadding: true,
    label: 'Email'
  },
  {
    id: 'customers_phone_number',
    numeric: false,
    disablePadding: true,
    label: 'Téléphone'
  },
  {
    id: 'isMember',
    bool: true,
    disablePadding: true,
    label: 'Membre',
    transform: value => value
  }
]
const columnDataMember = [
  {
    id: 'customers_last_name',
    numeric: false,
    disablePadding: true,
    label: 'Nom'
  },
  {
    id: 'customers_first_name',
    numeric: false,
    disablePadding: true,
    label: 'Prénom'
  },
  {
    id: 'customers_email',
    numeric: false,
    disablePadding: true,
    label: 'Email'
  },
  {
    id: 'customers_phone_number',
    numeric: false,
    disablePadding: true,
    label: 'Téléphone'
  },
  {
    id: 'isMember',
    bool: true,
    disablePadding: true,
    label: 'Membre',
    transform: value => value
  },
  {
    id: 'expirationDate',
    expiration: true,
    disablePadding: true,
    label: `Date d'expiration`
  }
]
const styles = theme => ({
  rootTabs: {
    flexGrow: 1,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    height: 51
  },
  container: {
    position: 'relative',
    overflow: 'hidden',
    paddingLeft: 8,
    paddingRight: 8
  },
  scrollContainer: {
    overflow: 'scroll',
    paddingLeft: 2,
    paddingRight: 2,
    paddingBottom: 4,
    width: 'calc(100%)',
    height: 'calc(100% - 64px)'
  },
  rootTab: {
    height: 51,
    maxWidth: 'none'
  }
})
export default withStyles(styles)(
  class CustomersComponent extends Component {
    static propTypes = {
      classes: PropTypes.object.isRequired,
      customers: PropTypes.array.isRequired,
      showModal: PropTypes.func.isRequired
    }
    state = {
      tabValue: 0,
      currentCategory: void 0
    }
    handleCreateProductClick = () => {
      this.props.showModal(MODAL_ADMIN_CREATE_CUSTOMER)
    }
    handleEditProductClick = customer => {
      this.props.showModal(MODAL_ADMIN_EDIT_CUSTOMER, customer)
    }
    handleDeleteClick = category => {
      // this.props.showModal(MODAL_ADMIN_DELETE_PRODUCT, category)
    }
    handleChange = (event, value) => {
      this.setState({ tabValue: value })
    }
    render() {
      const { classes, customers } = this.props
      const { tabValue } = this.state
      let currentCustomers = []
      switch (tabValue) {
        case 0:
          currentCustomers = customers
          break
        case 1:
          currentCustomers = customers.filter(c => c.isMember)
          break
        default:
      }
      return (
        <Grid
          className={classes.container}
          item
          container
          direction="row"
          alignItems="stretch"
          justify="flex-start">
          <Grid item xs={12}>
            <Tabs
              className={classes.rootTabs}
              value={tabValue}
              onChange={this.handleChange}
              fullWidth
              centered
              scrollButtons="off"
              indicatorColor="secondary">
              <Tab className={classes.rootTab} label="Tous les clients" />
              <Tab className={classes.rootTab} label="Membres" />
            </Tabs>
            <div className={classes.scrollContainer}>
              <AdminTableComponent
                title="Clients"
                search={['customers_last_name', 'customers_first_name']}
                selectable={false}
                list={currentCustomers}
                orderBy={'id'}
                columnData={tabValue === 0 ? columnDataAll : columnDataMember}
                addButtonAction={this.handleCreateProductClick}
                editButtonAction={this.handleEditProductClick}
              />
            </div>
          </Grid>
        </Grid>
      )
    }
  }
)



// WEBPACK FOOTER //
// ./src/routes/Customers/components/CustomersComponent.js